module.exports = __webpack_public_path__ + "static/media/ic-texto.3ebae94e.svg";